import { render, staticRenderFns } from "./ops_desk_settings.vue?vue&type=template&id=4f75618a&scoped=true&"
import script from "./ops_desk_settings.vue?vue&type=script&lang=js&"
export * from "./ops_desk_settings.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk_settings.vue?vue&type=style&index=0&id=4f75618a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f75618a",
  null
  
)

export default component.exports